export default "__VITE_ASSET__2e41447b__"